import { error, success, info, warning } from './Toast';

export const toast = {
  error,
  success,
  info,
  warning,
};
